export const GET_REVENUE_START = "GET_REVENUE_START";
export const GET_REVENUE = "GET_REVENUE";
export const GET_REVENUE_SUCCESS = "GET_REVENUE_SUCCESS";
export const GET_REVENUE_FAIL = "GET_REVENUE_FAIL";
